/* eslint-disable react/button-has-type */
/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/media-has-caption */
import React, { useState, useEffect } from 'react';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
import { LightboxContainer } from '@app/components/molecules/ImageLightbox/style';

const ExpandedMediaModal = ({ urls = [], startIndex, onClose }) => {
  const [currentIndex, setCurrentIndex] = useState(startIndex || 0);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    setCurrentIndex(startIndex || 0);
    if (urls.length > 0) {
      setIsOpen(true);
    }
  }, [startIndex, urls.length]);

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev > 0 ? prev - 1 : urls.length - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev + 1) % urls.length);
  };

  const isVideo = (url) => /\.(mp4|webm)$/i.test(url);

  if (!urls || urls.length === 0) { 
    onClose();
    return null;
  }

  return (
    <LightboxContainer>
      {isOpen && (
        isVideo(urls[currentIndex]) ? (
          <div className="custom-modal" style={{ 
            position: 'fixed', 
            top: 0, 
            left: 0, 
            right: 0, 
            bottom: 0, 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center', 
            backgroundColor: 'rgba(0, 0, 0, 0.8)'
          }}>
            <video controls style={{ maxWidth: '90%', maxHeight: '90%' }}>
              <source src={urls[currentIndex]} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            <button onClick={() => setIsOpen(false)}>Close</button>
          </div>
        ) : (
          <Lightbox
            mainSrc={urls[currentIndex]}
            nextSrc={urls[(currentIndex + 1) % urls.length]}
            prevSrc={urls[(currentIndex + urls.length - 1) % urls.length]}
            onCloseRequest={() => {
              setIsOpen(false);
              onClose();
            }}
            onMovePrevRequest={handlePrev}
            onMoveNextRequest={handleNext}
            imageTitle={`Image ${currentIndex + 1} of ${urls.length}`}
            reactModalStyle={{
              overlay: {
                zIndex: 9999,
              },
            }}
          />
        )
      )}
    </LightboxContainer>
  );
};

export default ExpandedMediaModal;
